import GeneratedChannelServiceApi from "./generated/GeneratedChannelServiceApi"

class ChannelServiceApi extends GeneratedChannelServiceApi {

}

export const channelServiceApi = new ChannelServiceApi()
